// extracted by mini-css-extract-plugin
export default {"item":"ContractView_item__IIL1Y","tools":"ContractView_tools__yNsNX"};